import Vue from 'vue'
import Vuex from 'vuex'
import MenuStore from '../store/store'
Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    MenuStore
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js